import { Component } from '@angular/core';
import { GeneralService } from '../../Services/generalservice.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-appliedjobs',
  templateUrl: './appliedjobs.component.html',
  styleUrls: ['./appliedjobs.component.scss']
})
export class AppliedjobsComponent {
    LoginDetails: any;
    HomeUrl: any;
    applieddata: any;
    constructor(public generalservice: GeneralService, private http: HttpClient,
        private router: Router) {
        debugger
        this.LoginDetails = JSON.parse(localStorage.getItem("userDetails"));
        


        this.http.get('../assets/WebService.json').subscribe((data: any) => {
            this.HomeUrl = data.Webservice;
            //this.HomeUrl = 'http://localhost:44341/'
        });

    }
    ngOnInit() {
        this.appliedjob();
    }
    appliedjob() {
        debugger
        var uploadfile = new FormData();
        uploadfile.append("SeekerID", this.LoginDetails.RegId);
        var url = "api/Njobs/Get_Seekar_AppliedJobs";
        this.generalservice.PostData(url, uploadfile).then(data => {
            debugger
            this.applieddata = data;
        });
    }
}
